import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitStata {
  number: number;
  defaultConfig: any;
}

const initialState: InitStata = {
  number: 0,
  defaultConfig: undefined,
};

const customerSlice = createSlice({
  name: 'share',
  initialState,
  reducers: {
    changeCount: (state = initialState, action: PayloadAction<number>) => {
      state.number = action.payload;
    },
    changeShareDefaultConfig: (state = initialState, action: PayloadAction<number>) => {
      state.defaultConfig	 = action.payload;
    },
  },
});

// 导出action
export const { changeCount, changeShareDefaultConfig } = customerSlice.actions;

export default customerSlice.reducer;
